import { render, staticRenderFns } from "./detailsThirdSupplierSupplyList.vue?vue&type=template&id=a5424d86"
import script from "./detailsThirdSupplierSupplyList.vue?vue&type=script&lang=js"
export * from "./detailsThirdSupplierSupplyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports